import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

// Drilling rig on a truck chassis (outline style, inherits the current text color)
const DrillRigIcon = (props) => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <g fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
            {/* mast */}
            <rect x="9.6" y="2" width="2.4" height="14" rx="0.6" />
            {/* drill head + drill string with pointed tip */}
            <rect x="3.6" y="3.6" width="3.6" height="4.2" rx="0.6" />
            <path d="M4.3 7.8v7.6l1.1 1.3 1.1-1.3V7.8" />
            <path d="M7.2 5.7h2.4" />
            {/* boom */}
            <path d="M12 9.3l3.9 4" />
            {/* chassis and cab */}
            <path d="M8.2 17.2v-3.7h13.6v3.7" />
            <path d="M16.2 13.5v-3.2h5.6v3.2" />
            {/* wheels */}
            <circle cx="11.8" cy="18.3" r="2.3" />
            <circle cx="18" cy="18.3" r="2.3" />
        </g>
    </SvgIcon>
);

export default DrillRigIcon;
